const getters = {
  token: (state) => state.user.token,
  name: (state) => state.user.token,
  info: (state) => state.user.info,
  chain_corp_id: (state) => state.user.chain_corp_id
}
export default getters
